import { C } from '../../shared/design-tokens.js';

// Mirrors the CHECK constraint on manager_activity_log.category
// (supabase/migrations/20260226000001_manager_activity_log.sql).
// If the backend enum grows, this list grows with it.
export const CATEGORY_OPTIONS = [
  { id: 'all',           label: 'All categories' },
  { id: 'auth',          label: 'Auth' },
  { id: 'clock',         label: 'Clock I/O' },
  { id: 'daily_entry',   label: 'Daily entry' },
  { id: 'directory',     label: 'Directory' },
  { id: 'scheduler',     label: 'Scheduler' },
  { id: 'fleet',         label: 'Fleet' },
  { id: 'permissions',   label: 'Permissions' },
  { id: 'onboarding',    label: 'Onboarding' },
  { id: 'scorecard',     label: 'Scorecard' },
  { id: 'safety',        label: 'Safety' },
  { id: 'bug_trap',      label: 'Bug trap' },
  { id: 'feature_flags', label: 'Feature flags' },
];

// Honest mapping: categories that the original executor meant to color
// are preserved; everything else falls back to textMuted so unmapped
// categories still display cleanly without inventing decorative palette.
const CATEGORY_COLOR: Record<string, string> = {
  auth:        C.gold,
  clock:       '#22C55E',
  fleet:       C.green,
  permissions: C.red,
  scheduler:   '#60A5FA',
  daily_entry: '#F97316',
};

export function categoryPresentation(category: string) {
  const color = CATEGORY_COLOR[category] || C.textMuted;
  return { color, background: `${color}15`, border: `${color}30` };
}

export function formatCategoryLabel(category: string | null | undefined): string {
  if (!category) return '—';
  return String(category).replace(/_/g, ' ');
}
